import type { WrappedFieldProps } from 'redux-form';

export const AddressDisplay = (addressDisplayFormProps: WrappedFieldProps) => (
    <input className='form-control' value={addressDisplayFormProps.input.value} disabled={true} />
);
